var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5080_95493)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5080_95493)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5080_95493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 0H6C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48H74C77.3137 48 80 45.3137 80 42V6C80 2.68629 77.3137 0 74 0Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.71 33.6833H32.059L34.9658 15.328H39.6174L36.71 33.6833ZM28.1462 15.328L23.712 27.9529L23.1873 25.2343L23.1878 25.2353L21.6228 16.9807C21.6228 16.9807 21.4336 15.328 19.4165 15.328H12.086L12 15.6388C12 15.6388 14.2417 16.118 16.8652 17.7368L20.906 33.6838H25.7521L33.1518 15.328H28.1462ZM64.7293 33.6833H69L65.2765 15.3275H61.5376C59.8111 15.3275 59.3906 16.6954 59.3906 16.6954L52.4538 33.6833H57.3023L58.2719 30.9568H64.1845L64.7293 33.6833ZM59.6113 27.1904L62.0552 20.3214L63.43 27.1904H59.6113ZM52.8175 19.742L53.4813 15.8003C53.4813 15.8003 51.4331 15 49.298 15C46.9899 15 41.5088 16.0365 41.5088 21.0765C41.5088 25.8186 47.9418 25.8775 47.9418 28.3683C47.9418 30.8591 42.1716 30.4128 40.2673 28.8421L39.5758 32.9635C39.5758 32.9635 41.6526 34 44.8257 34C47.9996 34 52.7879 32.3115 52.7879 27.7158C52.7879 22.9433 46.297 22.499 46.297 20.424C46.2975 18.3486 50.8272 18.6152 52.8175 19.742Z",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1878 25.2354L21.6228 16.9808C21.6228 16.9808 21.4336 15.3281 19.4165 15.3281H12.086L12 15.6389C12 15.6389 15.5233 16.3892 18.9028 19.2001C22.1341 21.8868 23.1878 25.2354 23.1878 25.2354Z",
    fill: "#E6A540"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5080_95493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5080_95493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5080_95493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisaCard);
export default __webpack_public_path__ + "static/media/ic-visa-card.86f90e4c77891b5fd2fe16468cc9affd.svg";
export { ForwardRef as ReactComponent };